import React from 'react'
import {
  Avatar,
  Box,
  Center,
  Heading,
  Stack,
  Text,
  Link as ChakraLink,
  useColorModeValue,
  Badge
} from "@chakra-ui/react";
import {Link} from "gatsby";
import {Maybe} from "../../gql/types";

export interface PostPreviewProps {
  link: string;
  author?: Maybe<string>;
  date: string;
  readingTime: number;
  title: string;
  tags: string[];
  intro?: Maybe<string>;
  heading?: Maybe<string>;
  isNew?: boolean;
}

const PostPreview: React.FC<PostPreviewProps> = ({
                                                   isNew,
                                                   tags,
                                                   link,
                                                   author,
                                                   date,
                                                   readingTime,
                                                   title,
                                                   intro,
                                                   heading
                                                 }) => {
  return (
    <Center p={6} w={'full'} minW={'50%'}>
      <Box bg={useColorModeValue('green.100', 'gray.800')} boxShadow={'2xl'} rounded={'md'} p={6}
           overflow={'hidden'}
      >
        <Center h={'210px'} mt={-6} mx={-6} mb={6} overflow={'hidden'} pos={'relative'}
                bg={useColorModeValue('gray.50', 'gray.200')}>
          <Heading bg={'linear-gradient(145deg, #2a9d8f, #264653)'} backgroundClip={'text'}
                   fontFamily={'"Overpass Mono"'} fontSize={'3xl'} fontWeight={800}>
            {heading}
          </Heading>
        </Center>
        <Stack>
          <Stack direction="row">
            {tags.map(tag => <Badge key={tag} variant={'solid'} colorScheme={'brand'}>{tag}</Badge>)}
          </Stack>
          <ChakraLink as={Link} to={link} color={useColorModeValue('brand.400', 'gray.50')} fontSize={'2xl'}
                      fontFamily={'body'}>
            {title}
            {isNew && <Badge variant={'solid'} colorScheme={'brand'} ml={1} mt={-3}>New</Badge>}
          </ChakraLink>
          <Text color={useColorModeValue('gray.800', 'gray.400')}>
            {intro}
          </Text>
        </Stack>
        <Stack mt={6} direction={'row'} spacing={4} align={'center'}>
          <Avatar src={'https://avatars.githubusercontent.com/u/6214415?s=48&v=4'} alt={'Johannes Klauss'}/>
          <Stack direction={'column'} spacing={0} fontSize={'sm'}>
            <Text fontWeight={600} color={useColorModeValue('brand.400', 'gray.50')}>{author}</Text>
            <Text color={useColorModeValue('gray.800', 'gray.400')}>{date} · {readingTime}min read</Text>
          </Stack>
        </Stack>
      </Box>
    </Center>
  )
}

export default PostPreview
